import React from 'react'
import { SupportScreen } from '../../../../components/settings/SupportScreen'
export default function SupportInboxScreen() {
  return <SupportScreen />
}
